import LayoutHeader from '@components/LayoutHeader'
import Panel from '@components/Panel'
import { cx } from 'styled-system/css'
import { Container, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'
import { PictureUpload } from './Image/PictureUpload'
import Profile from './Profile'
import Subscription from './Subscription'

export default function () {
  return (
    <Grid gridTemplateRows='auto 1fr' gap={0}>
      <LayoutHeader title="Settings" />
      <Panel height='calc(var(--vh) * 100 - 54px)' overflowY='auto' class={cx(
        scrollbar(),
      )} alignContent='start' >
        <Container display='grid' gap={3}>
          <Profile />
          <PictureUpload />
          <Subscription />
        </Container>
      </Panel>
    </Grid >
  )
}
